import React from 'react';
import './SectionHeader.css';

interface SectionHeaderProps {
  title: string;
  isExpanded?: boolean;
  onToggle?: () => void;
  clickable?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  title, 
  isExpanded = false, 
  onToggle, 
  clickable = false 
}) => {
  if (clickable && onToggle) {
    return (
      <button
        type="button"
        className={`section-header clickable ${isExpanded ? 'expanded' : ''}`}
        onClick={onToggle}
        aria-expanded={isExpanded}
      >
        <span className="section-title-text">{title}</span>
        <span className="expand-icon" aria-hidden="true">
          {isExpanded ? '−' : '+'}
        </span>
      </button>
    );
  }

  return (
    <div className="section-header">
      <div className="section-title-text">{title}</div>
    </div>
  );
};

export default SectionHeader; 
